export const carbon = {
  name: 'carbon',
  number: '6',
  weight: '12.011',
  symbol: 'C'
}
export const magnesium = {
  name: 'magnesium',
  number: '12',
  weight: '24.305',
  symbol: 'Mg'
}
export const aluminium = {
  name: 'aluminium',
  number: '13',
  weight: '26.982',
  symbol: 'Al'
}
export const silicon = {
  name: 'silicon',
  number: '14',
  weight: '28.085',
  symbol: 'Si'
}
export const phosphorus = {
  name: 'phosphorus',
  number: '15',
  weight: '30.974',
  symbol: 'P'
}
export const sulfur = {
  name: 'sulfur',
  number: '16',
  weight: '32.06',
  symbol: 'S'
}
export const chromium = {
  name: 'chromium',
  number: '24',
  weight: '51.996',
  symbol: 'Cr'
}
export const manganese = {
  name: 'manganese',
  number: '25',
  weight: '54.938',
  symbol: 'Mn'
}
export const iron = {
  name: 'iron',
  number: '26',
  weight: '55.845',
  symbol: 'Fe'
}
export const cobalt = {
  name: 'cobalt',
  number: '27',
  weight: '58.933',
  symbol: 'Co'
}
export const nickel = {
  name: 'nickel',
  number: '28',
  weight: '58.693',
  symbol: 'Ni'
}
export const copper = {
  name: 'copper',
  number: '29',
  weight: '63.546',
  symbol: 'Cu'
}
export const zinc = {
  name: 'zinc',
  number: '30',
  weight: '65.38',
  symbol: 'Zn'
}
export const niobium = {
  name: 'niobium',
  number: '41',
  weight: '92.906',
  symbol: 'Nb'
}
export const molybdenum = {
  name: 'molybdenum',
  number: '42',
  weight: '95.95',
  symbol: 'Mo'
}
export const lead = {
  name: 'lead',
  number: '82',
  weight: '207.2',
  symbol: 'Pb'
}



// WEBPACK FOOTER //
// ./src/utils/periodictable.js